/*jslint esnext: true */
/*global jQuery, dis, _, Modernizr */

/* DIS/PLAY Script
 Author's name: Anders Gissel
 Modified by:
 Client name: Hørsholm municipality
 Date of creation: Dec. 16th, 2015
 */


(function ($, dis, underscore) {
	"use strict";


	/**
	 * This module handles whatever small tasks don't fit into anything else.
	 *
	 * @constructor
	 * @extends dis.BaseModule
	 */
	dis.ui.Miscellaneous = function () {

		// Fire the basemodule-initiator on this module.
		dis.BaseModule.call(this);

		var handlers,
			selfScope = this;


		function evenHeights($elements){
			if($elements.length){
				var maxHeight = 0, elemHeight;
				$elements.each(function(){
					elemHeight = $(this).innerHeight();
					maxHeight = elemHeight > maxHeight ? elemHeight : maxHeight;
				});
				$elements.css("height", maxHeight);
			}
		}


		handlers = {

			handleHoverstatesOnRibbonContentLinks: function () {
				if (!Modernizr.touchevents) {
					$("a.ribbon__content").hover(
						function () {
							$(this).parents(".ribbon:first").addClass("ribbon--hover");
						},
						function () {
							$(this).parents(".ribbon:first").removeClass("ribbon--hover");
						}
					);
				}

			},


			handleKeypressesOnHiddenCheckboxes: function () {

				$("input.hidden-checkbox").keydown(function (e) {
					if (e.which === 13) {
						e.preventDefault();
						$(this).trigger("click");
					}
				});

			},


			handleDismissalLinks: function () {

				$("[data-dismissparent]").click(function (e) {
					e.preventDefault();
					$(this).parents("[data-dismisstarget]").addClass("hidden");
				});

			},


			handleVideos: function () {
				$("[class*='__video']").fitVids();
			},


			removeHeightFromImages: function () {
				// The RTE will insert images with "hardcoded" width and height in the style-property. This is all well
				// and good, but we don't want height to be fixed in case the image should be responsive. So we'll just
				// remove that pesky little thing.
				$(".text-ribbon img[style]").css("height", "");
			},


			addHelperClasses: function () {

				selfScope.globalDOM.html.toggleClass("ios-safari", selfScope.isMobileSafari);

			},



			handleEmptySearchField: function () {

				// If the user tries to submit the header search form without having filled anything in, we'll stop the
				// execution and instead set focus in the search field.
				$("#headerWrapper .header-search").submit(function (e) {

					var field = $(this).find("input[type=search]"),
						fieldValue = $.trim(field.val());

					if (!fieldValue) {
						e.preventDefault();
						e.stopPropagation();

						field.focus().removeClass("header-search__field--emphasize");

						window.setTimeout(function () {
							field.addClass("header-search__field--emphasize");
						}, 50);
					}

				});

			},

			/**
			 * This function evens out height difference of flex elements on browsers that do not support flex stretch features.
			 */
			handleFlexHeights: function () {
				// Even-out heights of flex-box elements
				if (!Modernizr.flexbox) {
					evenHeights($(".frontpage-ribbon__content > nav"));
					evenHeights($(".secondary-cta-box"));
				}
			},



			handleSocialPopups: function () {

				$(".social-icons__link").click(e => {
					e.preventDefault();
					let element = $(e.currentTarget);
					let width = element.data("width") || 580;
					let height = element.data("height") || 520;
					let url = element.attr("href");
					window.open(url, '', `width=${width},height=${height}`);
				});

			}

		};

		/**
		 * Initialization function, which is run when the module is "booting".
		 */
		function init() {

			// Fire ALL handlers when ready.
			underscore.each(handlers, function (functionReference) {
				functionReference();
			});

		}

		// Once everything is ready, run the init-function to get the ball rolling. The "onReady()" function lives
		// in dis.base.js.
		selfScope.onReady(init);

	};

	dis.ui.Miscellaneous.prototype = new dis.BaseModule();
	dis.ui.Miscellaneous.constructor = dis.ui.Miscellaneous;

}(jQuery, dis, _));